import React from "react";

function NewRealmDeFi() {
  return (
    <div className="about-area pt-5 pb-5 mt-5">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6 text-center">
            <div className="thumb">
              <img
                src="/assets/img/illustration/2.png" // placeholder
                alt="The New Realm of DeFi"
                style={{ maxWidth: "90%", borderRadius: "10px" }}
              />
            </div>
          </div>
          <div className="col-lg-6">
            <div className="">
              <h2
                className="title split-lines mb-4"
                style={{ fontWeight: "bold" }}
              >
                The New Realm of DeFi & Its Future Scope
              </h2>
              <p style={{ fontSize: "16px", color: "#555", lineHeight: "1.8" }}>
                Decentralized Finance (DeFi) fundamentally restructures
                traditional monetary systems by eliminating centralized
                intermediates through highly secure autonomous smart contracts.
                Users govern transactions completely, unlocking immense
                flexibility and unprecedented speeds across lending, staking,
                and decentralized liquidity ecosystems globally.
              </p>
              <p
                className="mt-3"
                style={{ fontSize: "16px", color: "#555", lineHeight: "1.8" }}
              >
                The future trajectory of DeFi predicts extreme mass adoption,
                blending seamlessly into legacy financial frameworks and
                propelling trillion-dollar decentralized economies. Custom
                protocols continue scaling aggressively, bringing profound
                transparency, lower fees, and dynamic modular financial
                instruments directly to mobile users worldwide.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NewRealmDeFi;
